module.exports = __webpack_public_path__ + "img/3.6a2a3921.png";